import { render, staticRenderFns } from "./RouteConfigList.vue?vue&type=template&id=ba32a688&scoped=true"
import script from "./RouteConfigList.vue?vue&type=script&lang=js"
export * from "./RouteConfigList.vue?vue&type=script&lang=js"
import style0 from "./RouteConfigList.vue?vue&type=style&index=0&id=ba32a688&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba32a688",
  null
  
)

export default component.exports